jQuery(document).ready(function ($) {


    /**
     * 
     * PAGINA ELENCO OGGETTI
     * 
     * 
     * 
     */
        
    /*
     * DATATABLE
     */
    var commonOLangTabelleOggetti = {
        "sLengthMenu": "Mostra _MENU_ risultati per pagina",
        "sZeroRecords": "Nessun oggetto trovato",
        "sInfo": "Visualizzati oggetti da _START_ a _END_ di _TOTAL_ risultati",
        "sInfoEmpty": "Mostra 0 su 0 di 0 risultati",
        "sInfoFiltered": "(Filtrati da _MAX_ risultati totali)",
        "sSearch": "Filtra:",
        "oPaginate": {
            "sFirst": "|<",
            "sLast": ">|",
            "sNext": ">",
            "sPrevious": "<"
        }
    };

    $('#table-elenco-oggetti-offerti_regalo').DataTable({
        responsive: true,
        /*"columns": [
            {"data": "Oggetto"},
            {"data": "Data annuncio"},
            {"data": "Stato"},
            {"data": "Beneficiario"},
            {"data": "Azioni"}
        ],*/
        "fnDrawCallback": reinizializzaTooltips,
        "oLanguage": commonOLangTabelleOggetti,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [4]}],
        "order": [[ 1, "desc" ]]
    });    
    $('#table-elenco-oggetti-ricevuti_regalo').DataTable({
        responsive: true,
        /*"columns": [
            {"data": "Oggetto"},
            {"data": "Ex proprietario"},
            {"data": "Stato"},
            {"data": "Feedback"},
            {"data": "Azioni"}
        ],*/
        "fnDrawCallback": reinizializzaTooltips,
        "oLanguage": commonOLangTabelleOggetti,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [4]}],
        "order": [[ 2, "desc" ]]
    });    
    $('#table-elenco-oggetti-dati_prestito').DataTable({
        responsive: true,
        /*"columns": [
            {"data": "Oggetto"},
            {"data": "Data annuncio"},
            {"data": "Stato"},
            {"data": "Beneficiario"},
            {"data": "Azioni"}
        ],*/
        "fnDrawCallback": reinizializzaTooltips,
        "oLanguage": commonOLangTabelleOggetti,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [4]}],
        "order": [[ 1, "desc" ]]
    });   
    $('#table-elenco-oggetti-ricevuti_prestito').DataTable({
        responsive: true,
        /*"columns": [
            {"data": "Oggetto"},
            {"data": "Proprietario"},
            {"data": "Stato"},
            {"data": "Azioni"}
        ],*/
        "fnDrawCallback": reinizializzaTooltips,
        "oLanguage": commonOLangTabelleOggetti,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [3]}],
        "order": [[ 2, "desc" ]]
    });    
    $('#table-elenco-oggetti-senza_annuncio').DataTable({
        responsive: true,
        /*"columns": [
            {"data": "Oggetto"},
            {"data": "Azioni"}
        ],*/
        "fnDrawCallback": reinizializzaTooltips,
        "oLanguage": commonOLangTabelleOggetti,
        "aoColumnDefs": [{"bSortable": false, "aTargets": [1]}],
        "order": [[ 0, "desc" ]]
    });


    
    
    /*
     * BOTTONI
     */
    
    $(document).on('click', '.button-modifica-oggetto', function () {
        window.location.href = wpdm_modifica_oggetti_url + '?id_oggetto=' + this.value;
    });
    $(document).on('click', '.button-storia-oggetto', function () {
        window.location.href = wpdm_storia_oggetti_url + '?id_oggetto=' + this.value;
    });
    $(document).on('click', '.button-restituzione-prestito-oggetto', function () {

        var r = confirm("Sei sicuro di volere restituire l'oggetto al suo legittimo proprietario?");
        if (r == true) {
            themeSpinner('show');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                cache: false,
                url: ajax_url,
                data:
                        {
                            action: 'restituzione_prestito_oggetto_action',
                            id_oggetto: this.value

                        },
                dataType: "html", //expect html to be returned                
                success: function (response) {
                    themeSpinner('hide');
                    location.reload(true);
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageSelectObject").html('Problemi nel restituire l\' oggetto');
                    $("#messageSelectObject").addClass('alert-danger');
                    $("#messageSelectObject").show();
                }

            });
        }
    });
    $(document).on('click', '.button-eliminazione-oggetto', function () {

        var r = confirm("Sei sicuro di volere rendere non disponibile questo oggetto?");
        if (r == true) {
            themeSpinner('show');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                cache: false,
                url: ajax_url,
                data:
                        {
                            action: 'elimina_oggetto_action',
                            id_oggetto: this.value

                        },
                dataType: "html", //expect html to be returned                
                success: function (response) {
                    themeSpinner('hide');
                    location.reload(true);
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageSelectObject").html('Problemi nell\'eliminazione dell\' oggetto');
                    $("#messageSelectObject").addClass('alert-danger');
                    $("#messageSelectObject").show();
                }

            });
        }
    });
    $(document).on('click', '.button-recupera-oggetto', function () {

        var r = confirm("Sei sicuro di volere recuperare questo oggetto?");
        if (r == true) {
            themeSpinner('show');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                cache: false,
                url: ajax_url,
                data:
                        {
                            action: 'recupera_oggetto_action',
                            id_oggetto: this.value

                        },
                dataType: "html", //expect html to be returned                
                success: function (response) {
                    themeSpinner('hide');
                    location.reload(true);
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageSelectObject").html('Problemi nel recupero dell\' oggetto');
                    $("#messageSelectObject").addClass('alert-danger');
                    $("#messageSelectObject").show();
                }

            });
        }
    });
});
